import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrandsStoreModule } from './brands-store/brands-store.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BrandsStoreModule
  ]
})
export class BrandsModalsModule { }
